import $ from 'jquery';

export default {

  init: function (posterEl, trailersSlices) {
    this.posterEl = posterEl;
    this.preloadAll(trailersSlices);
  },

  fadeIn: function () {
    this.posterEl.fadeIn();
  },

  fadeOut: function () {
    this.posterEl.fadeOut();
  },

  loadNext: function () {
    this.posterEl.css('background-image', 'url(' + $('#trailersSlices').find('.active').data('poster') + ')');
    this.fadeIn();
  },

  // preload all trailer slice images
  preloadAll: function (trailersSlices) {
    let self = this;

    let elements = (trailersSlices);
    let imgs = [];

    for (let i = 0; typeof (elements[i]) !== 'undefined'; i++) {
      imgs.push(elements[i].getAttribute('data-poster'));
    }

    let loaded = 0;

    for (let i = 0; i < imgs.length; i++) {
      let image = new Image();
      image.src = imgs[i];
      image.onload = function () {
        loaded++;

        if (loaded === 1) {
          self.fadeIn();
        }

        if (loaded === imgs.length) {
          //console.log('all loaded')
        }
      };
    }
  },
};
